import getCharts from '../getCharts'
import { SavePatientDiagnosis } from '../../constants/api.config'

export default async function SavePatientDiagnosisData(patientID,diagnosis, diagnosisDetails, status) {
  try {
    const payload = {patientID,diagnosis, diagnosisDetails, status}
    const res = await getCharts(SavePatientDiagnosis, payload)
    return res.data
  } catch (error) {
    return error
  }
}
